import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { VehicleForm } from "@/app/Vehicles/Forms/VehicleForm";
import { CreateVehicleInput, VehicleListFieldsFragment } from "@/gql/graphql";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { createVehicleSchema } from "@/app/Vehicles/Validators/createVehicleSchema";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createVehicleMutation } from "@/app/Vehicles/GraphQL/vehicleMutations";
import { useGlobalSupplier } from "@/app/Suppliers/Utils/useGlobalSupplier";
import { useGetInitialVehicleValues } from "@/app/Vehicles/Utils/useGetInitialVehicleValues";
import { SupplierRecord } from "@/app/Suppliers/GraphQL/supplierRecordQuery";
import { DialogComponent } from "@/lib/Components/Dialog/Hooks/useDialog";

type VehicleCreateDialogProps = {
  initialValues?: Partial<CreateVehicleInput>;
  initialSupplier?: SupplierRecord;
};

export const VehicleCreateDialog: DialogComponent<
  VehicleCreateDialogProps,
  VehicleListFieldsFragment
> = ({ initialValues, initialSupplier }) => {
  const { mutateAsync } = useGqlMutation(createVehicleMutation);
  const { close, resolve } = useDialogState<VehicleListFieldsFragment>();
  const { supplier } = useGlobalSupplier();
  const initialInput = useGetInitialVehicleValues(initialSupplier ?? supplier);

  return (
    <BaseDialog title="Add vehicle">
      <GenericForm<CreateVehicleInput>
        validationSchema={toFormikValidationSchema(createVehicleSchema)}
        onSubmit={async (values) => {
          const res = await mutateAsync({
            input: values,
          });

          resolve?.(res.createVehicle);

          return close();
        }}
        initialValues={{
          ...initialInput,
          ...initialValues,
        }}
      >
        <VehicleForm />
        <DialogSubmitButton text={"Add vehicle"} />
      </GenericForm>
    </BaseDialog>
  );
};
